import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import styled, { css } from 'styled-components';
import { SmartContainer } from '../Containers';
import { LinearProgress } from '@mui/material';

export const StyledCircularProgress = styled(CircularProgress)`

    ${props => (props.size === 'small') ? css` width: 20px;` : ''}
`;

export const StyledCircularProgressWithLabel = (props) => {
    return (
        <SmartContainer {...props}>
            <StyledCircularProgress variant="determinate" value={props.value} />
        </SmartContainer>
    )
}

export const StyledLinearProgress = styled(LinearProgress)`

    ${props => (props.size === 'small') ? css` width: 20px;` : ''}
`;

export const StyledLinearProgressWithLabel = (props) => {
    return (
        <SmartContainer {...props}>
            <StyledLinearProgress variant="determinate" value={props.value} />
        </SmartContainer>
    )
}